import type {
  SubscriptionStatusType,
  PlanType,
  PaymentCycleType
} from '@/src/store/apis/subscription/interface';
import { SUBSCRIPTION_STATUS, SUBSCRIPTION_TYPE } from '@/src/constant/login';
import { TFunction } from "i18next";

export const CARD_NUMBER_CHECK_LENGTH = 0;

export const convertPaymentTypeToString = (
  plan: PaymentCycleType,
  t: TFunction,
) => {
  switch (plan) {
    case "MONTHLY":
      return t("subscriptionPlanSignup:paymentTypeMonthly");
    case "ANNUALLY":
      return t("subscriptionPlanSignup:paymentTypeAnnually");
    default:
      throw new Error("Unknown paymentType type");
  }
};

// Helper function to determine subscription display type
export const getSubscriptionDisplayType = (
  subscriptionStatus: SubscriptionStatusType | undefined,
  subscriptionType: string | undefined,
  planType?: PlanType
): SubscriptionStatusType | PlanType | undefined => {
  // Return undefined if subscriptionStatus is missing
  if (!subscriptionStatus) {
    return undefined;
  }

  // Use planType only when status is PROGRESS and type is not FREE
  if (subscriptionStatus === SUBSCRIPTION_STATUS.PROGRESS && subscriptionType !== SUBSCRIPTION_TYPE.FREE && planType) {
    return planType;
  }

  // Return subscriptionStatus as-is for all other cases
  return subscriptionStatus;
};

// Type guard functions
export const isSubscriptionStatus = (
  value: string
): value is SubscriptionStatusType => {
  return [
    SUBSCRIPTION_STATUS.PROGRESS,
    SUBSCRIPTION_STATUS.FINISHED,
    SUBSCRIPTION_STATUS.CANCELED,
    SUBSCRIPTION_STATUS.NOT_PAID_YET,
    SUBSCRIPTION_STATUS.PAYMENT_FAIL
  ].includes(value as SubscriptionStatusType);
};

export const isPlanType = (
  value: string
): value is PlanType => {
  return ['NORMAL', 'ENTERPRISE'].includes(value);
};